import {createSlice, PayloadAction} from "@reduxjs/toolkit";


export interface PayerDatum {
	  name: string;
	  payingFor: number;
}

export interface PayerPayload {
	  index: number;
	  name: string;
	  payingFor: number;
}


export const payerSliceName = "payer";

const payerSlice = createSlice({
	  name: payerSliceName,
	  initialState: [{name: "", payingFor: 0}],
	  reducers: {
			 updatePayer: (state, action: PayloadAction<PayerPayload>) => {
					const {index, name, payingFor}: PayerPayload = action.payload;
					state[index] = {name, payingFor};
			 },
			 resetAllPayers: (state, action:PayloadAction<Number>) => {
					state.length = action.payload;
			 }
	  }
});

export const {updatePayer, resetAllPayers} = payerSlice.actions;

const payerReducer = payerSlice.reducer;
export default payerReducer;